import { useState } from 'react'
import { Autocomplete, TextField, createFilterOptions } from '@mui/material'
import countries from './countries.json'
import css from './CountrySelect.module.css'

const getSelectedValue = countryCode => {
  if (!countryCode) return null
  return countries.find(c => c.code === countryCode) || null
}

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: option =>
    `${option.name} ${option.callingCode} ${option.callingCode.replace('+', '')}`
})

const CountrySelect = ({ name, value, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const handleChange = (event, selectedCountry) => {
    if (selectedCountry === null) onChange(null)
    else onChange(selectedCountry.code)
    setInputValue('')
  }

  const handleInputChange = (event, newInputValue, reason) => {
    if (reason === 'input') setInputValue(newInputValue)
    else if (reason === 'reset') setInputValue('')
  }

  const selectedCountry = getSelectedValue(value)

  return (
    <Autocomplete
      id={name}
      className={css.select}
      options={countries}
      value={selectedCountry}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disabled={disabled}
      disableClearable
      filterOptions={filterOptions}
      getOptionLabel={option => `${option.name} (${option.callingCode})`}
      ListboxProps={{ style: { maxHeight: '300px' } }}
      slotProps={{ popper: { style: { width: '300px' } } }}
      renderOption={(props, option) => (
        <li {...props} key={option.code}>
          <span className={css.emoji}>{option.emoji}</span>
          <span className={css.countryName}>{option.name}</span>
          <span className={css.callingCode}>({option.callingCode})</span>
        </li>
      )}
      renderInput={params => {
        return (
          <TextField
            {...params}
            variant='standard'
            placeholder={selectedCountry ? selectedCountry.emoji : '🌍'}
            className={css.input}
            inputProps={{
              ...params.inputProps,
              value:
                !open && selectedCountry
                  ? selectedCountry.emoji
                  : params.inputProps.value
            }}
          />
        )
      }}
    />
  )
}

export default CountrySelect
